import React from 'react'

const NotAuthenticate = () => {
  return (
    <div>NotAuthenticate</div>
  )
}

export default NotAuthenticate